import styled from 'styled-components';
import { Fab } from '@mui/material';

export const StyledFab = styled(Fab)`
  && {
    position: fixed;
    bottom: 30px;
    right: 30px;
    background-color: #25d366;
    z-index: 9999;

    &:hover {
      background-color: #128c7e;
    }
  }
`;
